export const selectLaunchTarget = ({ hasSession, search = '', hash = '' }) =>
  hasSession ? null : `/app/login${search}${hash}`;
